(() => {
  'use strict';

  const COOLER_VARIANT_ID = 47319391043745;
  const GIFT_PROPERTY = '_mythk_bf_gift';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  let busy = false;
  let timer = null;

  const endpoint = (path) => root.replace(/\/$/, '/') + path.replace(/^\//, '');

  async function getCart() {
    const response = await nativeFetch(endpoint('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  function splitCoolerLines(cart) {
    const paid = [];
    const gifts = [];

    for (const item of cart.items || []) {
      if (Number(item.variant_id) !== COOLER_VARIANT_ID) continue;
      const isGift = item.properties && String(item.properties[GIFT_PROPERTY]) === 'true';
      (isGift ? gifts : paid).push(item);
    }

    return {
      paidQty: paid.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
      giftQty: gifts.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
      gifts
    };
  }

  async function addGift() {
    const response = await nativeFetch(endpoint('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: COOLER_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROPERTY]: 'true' }
        }]
      })
    });
    if (!response.ok) throw new Error('Unable to add Black Friday gift');
  }

  async function removeGiftLines(gifts) {
    for (const item of gifts) {
      const response = await nativeFetch(endpoint('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
      if (!response.ok) throw new Error('Unable to update Black Friday gift');
    }
  }

  function refreshCartUi(cart, changed) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
    });

    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart);
    }

    document.dispatchEvent(new CustomEvent('mythk:black-friday-cart-updated', {
      detail: { cart, changed }
    }));

    if (changed && /\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  async function syncGift() {
    if (busy) return;
    busy = true;

    try {
      let cart = await getCart();
      const state = splitCoolerLines(cart);
      let changed = false;

      if (!window.mythkBlackFridayStarted) {
        if (state.giftQty > 0) {
          await removeGiftLines(state.gifts);
          changed = true;
        }
      } else if (state.paidQty === 3 && state.giftQty === 0) {
        await addGift();
        changed = true;
      } else if (state.paidQty !== 3 && state.giftQty > 0) {
        await removeGiftLines(state.gifts);
        changed = true;
      } else if (state.paidQty === 3 && state.giftQty > 1) {
        await removeGiftLines(state.gifts);
        await addGift();
        changed = true;
      }

      if (changed) cart = await getCart();
      // Never leave an automatically added item in the cart at a charge.
      if (window.mythkBlackFridayStarted) {
        const gifts = splitCoolerLines(cart).gifts;
        if (gifts.some(item => Number(item.final_line_price) !== 0)) {
          await removeGiftLines(gifts);
          changed = true;
          cart = await getCart();
        }
      }
      refreshCartUi(cart, changed);
    } catch (error) {
      console.error('[MYTHK Black Friday] Free item sync failed:', error);
    } finally {
      busy = false;
    }
  }

  function scheduleSync(delay = 250) {
    clearTimeout(timer);
    timer = setTimeout(syncGift, delay);
  }

  const trackedFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await trackedFetch(...args);
    try {
      const rawUrl = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
      if (rawUrl && /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(rawUrl)) {
        scheduleSync();
      }
    } catch (_) {}
    return response;
  };

  if (window.jQuery) {
    window.jQuery(document).ajaxComplete((_event, _xhr, settings) => {
      if (settings && settings.url && /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(settings.url)) {
        scheduleSync();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => scheduleSync(100));
  window.addEventListener('pageshow', () => scheduleSync(100));
})();